<svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.13325 6.59992L1.39992 12.3333L0.466585 11.3999L5.26659 6.59992L0.333251 1.66659L1.26658 0.733255L7.13325 6.59992Z" fill="black"/>
</svg>
